import { snapshotStore as localStorage } from "../local/device-store";
import { useCallback, useEffect, useState } from "react";
import type { CaseResponse } from "../../../../packages/core/src/types";
import { fetchCaseList, readCaseSnapshot, writeCaseSnapshot } from "../api-client";
import { normalizedRoute, trackProductEvent } from "../telemetry";

export function useCases(mode: "missing" | "protected" = "missing") {
 const [data, setData] = useState<CaseResponse | null>(null);
 const [message, setMessage] = useState("");
 const [viewState, setViewState] = useState<"loading" | "ready" | "empty" | "error" | "offline">("loading");
 const load = useCallback(() => {
  setViewState("loading");
  const snapshot = readCaseSnapshot(localStorage, mode);
  const route = normalizedRoute();
  const unavailable = (offline: boolean) => {
   const message = offline
    ? snapshot ? "오프라인이라 최근 저장된 목록을 보여드려요." : "오프라인이고 저장된 목록이 없어요."
    : snapshot ? "새 정보를 불러오지 못해 최근 저장된 목록을 보여드려요." : "연결을 확인하지 못해 공개 목록을 불러올 수 없어요.";
   if (snapshot?.checkedAt) trackProductEvent({event: "stale_snapshot_shown", route, props: {staleMinutes: Math.min(10_080, Math.max(0, Math.round((Date.now() - Date.parse(snapshot.checkedAt)) / 60_000))), consecutiveFailures: 1}});
   if (!offline || !snapshot) trackProductEvent({event: "error_shown", route, props: {code: "AB-5001", route}});
   setData(snapshot ? {...snapshot, sourceStatus: "upstream_error", message} : null);
   setMessage(message);
   setViewState(offline ? "offline" : "error");
  };
  if (!navigator.onLine) { unavailable(true); return; }
  void fetchCaseList(mode).then(payload => {
   if (payload.sourceStatus === "live") writeCaseSnapshot(localStorage, mode, payload);
   setData(payload); setMessage(payload.message ?? "");
   setViewState(payload.sourceStatus !== "live" ? "offline" : payload.items.length ? "ready" : "empty");
  }).catch(() => unavailable(false));
 }, [mode]);
 useEffect(() => { load(); addEventListener("online", load); addEventListener("offline", load); return () => { removeEventListener("online", load); removeEventListener("offline", load); }; }, [load]);
 return {data, message, loading: viewState === "loading", viewState, reload: load};
}
